import React, { useState, useEffect } from "react";
import "../Styles/CreateNewClient.css";
import logo from "../assests/images/menubar_logo.png";
import BackgroundInfoSection from "./BackgroundInfoSection";
import AddFamilyMemeberForClient from "./AddFamilyMemeberForClient";
import EducationWorkForm from "./EducationWorkForm";
import PhysicalAttributesForm from "./PhysicalAttributesForm";
import EditPhotographUploader from "./EditPhotographUploader";
import LifestyleAndInterests from "./LifestyleAndInterests";
import VideoAndDocumentsUploader from "./VideoAndDocumentsUploader";
import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  PROFILE_LOGIN,
  USER_ID,
} from "../utils/store-data-constants";
import { getData } from "../utils/store-data";
import Select from "react-select";
import {
  check_phone_no,
  get_castes,
  get_communities,
  get_country_states,
  get_district_cities,
  get_habits,
  get_hobbies,
  get_language,
  get_marital_status,
  get_physical_build,
  get_qualification,
  get_religios,
  get_skin_tone,
  get_state_districts,
  update_client_photo,
  update_profile_photo,
  update_profile_video,
  get_relations,
  edit_profile,
  get_profile_byid,
  get_level3_caste,
  get_level1_caste,
  get_level2_caste,
  get_country_list,
  get_cities,
  get_states,
  get_all_countries,
  create_matches_by_preference,
  update_profile_document,
  get_client,
  get_client_relations,
  get_commmunity_docs,
  set_main_profile_photo,
  check_email,
} from "../api/serverWrapper";
import { log_debug, log_info } from "../utils/log";
import UserInfo from "../components/UserInfo";
import Profile from "../components/Profile";
import { useLocation, useNavigate } from "react-router-dom";
import Address from "../components/Address";
import AddFamilyWealthForClient from "./AddFamilyWealthForClient";
import { customStyles } from "../utils/commonFunctions";
import { useMasterData } from "../context/MasterDataContext";

export default function EditClientProfile() {
  const {
    religionMasterData,
    countryMasterData,
    allCasteMasterData,
    maritalStatusMasterData,
    skinToneMasterData,
    buildMasterData,
    habitsMasterData,
    hobbiesMasterData,
    qualificationMasterData,
    communityMasterData,
    languageMasterData,
    relationsMasterData,
    clientRelationsMasterData,
    communityDocsMasterData,
    allCountyMasterData,
  } = useMasterData();
  const location = useLocation();
  const client = location.state?.client;

  // console.log("client for edit", client);

  let [userIdForProfile, setUserIdForProfile] = useState(client?.UserId);
  let [profileId, setProfileId] = useState(client.ProfileId);
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedRelationFrClient, setSelectedRelationFrClient] = useState(
    client?.ClientRelationId,
  );
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentStep]);

  const [btnLoading, setBtnLoading] = useState(false);

  let [profileData, setProfileData] = useState(new Profile());
  let [userData, setUserData] = useState(new UserInfo());
  let [UserDataMatchPrep, setUserDataMatchPrep] = useState(null);
  const [accessOnRequest, setAccessOnRequest] = useState(
    client.IsPhotoVisible || false,
  );
  const [Loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState(client?.User?.FirstName);
  const [lastName, setLastName] = useState(client?.User?.LastName);
  const [middleName, setMiddleName] = useState("");
  const [collageName, setCollageName] = useState(client.CollageName);
  const [jobRole, setJobRole] = useState(client.JobRole);
  const [height, setHeight] = useState(client?.Height || "");
  const [weight, setWeight] = useState(client?.Weight || "");
  const [desc, setDesc] = useState(client?.ProfileDescription || "");
  const [Salary, setSalary] = useState(client?.Salary);

  const [salaryCurrency, setSalaryCurrency] = useState(
    client?.SalaryCurrency || "",
  );

  const [phoneNumber, setPhoneNumber] = useState(
    client?.User?.PhoneNumber || "",
  );

  const [email, setEmail] = useState(client?.User?.EMail || "");

  const [carrerGoals, setcarrerGoals] = useState(client?.CarrerGoals || "");
  const [familyDetails, setFamilyDetails] = useState([]);
  const [familyWealth, setFamilyWealth] = useState([]);

  const [languages, setLanguage] = useState(languageMasterData || []);
  const [selectedLanguage, setSelectedLanguage] = useState(
    client.User.UserLanguage || [],
  );

  const [selectedRelation, setSelectedRelation] = useState(client?.RelationId);
  const [selectedQualification, setSelectedQualification] = useState(
    client?.QualificationId || "",
  );
  const [selectedGender, setSelectedGender] = useState(client?.User?.Gender);
  console.log("client?.User?.Gender : ", client?.User?.Gender);

  const handleQualificationDataFromChild = (e) => {
    let id = Number(e.target.value);
    setSelectedQualification(id);
  };

  const handleGenderDataFromChild = (e) => {
    const id = Number(e.target.value);
    setSelectedGender(id);
  };

  let [UserId, setUserId] = useState(null);
  let [profileLogin, setProfileLogin] = useState(false);
  let [parentID, setParentId] = useState(null);
  let [cleintGender, setClientGender] = useState(1);
  const [isClient, setIsClient] = useState(false);
  const [religion, setReligion] = useState(religionMasterData || []);
  const [countries, setCountries] = useState([]);
  const [countryCode, setCountryCode] = useState(
    client?.User?.Address?.CountryId || "",
  ); // e.g. "IN"
  const [states, setStates] = useState([]);

  const [cities, setCities] = useState([]);
  const [countryList, setCountryList] = useState(countryMasterData || []);
  const [selectedResidence, setSelectedResidence] = useState(
    client?.User?.Address?.ResidenceId || "",
  );
  const [selectedCitizenship, setSelectedCitizenship] = useState(
    client?.User?.Address?.CitizenshipId || "",
  );
  const [seletedEthinicity, setSelectedEthinicity] = useState(
    client?.User?.Address?.Ethinicity || "",
  );

  const [postalcode, setPostalCode] = useState(
    client?.User?.Address?.PostalCode || "",
  );
  const [level1Caste, setLevel1Caste] = useState([]);
  const [level2Caste, setLevel2Caste] = useState([]);
  const [level3Caste, setLevel3Caste] = useState([]);
  const [communityList, setCommunity] = useState(communityMasterData || []);
  const [maritalStatus, setMaritalStatus] = useState(
    maritalStatusMasterData || [],
  );
  const [relationsForClient, setRelationsForClients] = useState([]);
  const [skinToneList, setSkinToneList] = useState(skinToneMasterData || []);
  const [physicalbuildList, setPhysicalBuildList] = useState(
    buildMasterData || [],
  );
  const [habitList, setHabitList] = useState(habitsMasterData || []);
  const [hobbiesList, setHobbiesList] = useState(hobbiesMasterData || []);
  const [qualifications, setQualifications] = useState(
    qualificationMasterData || [],
  );
  const [communitieDocs, setCommuniteDocs] = useState(
    communityDocsMasterData || [],
  );

  const [selectedState, setSelectedState] = useState(
    client?.User?.Address?.StateId || "",
  );

  const [selectedCity, setSelectedCity] = useState(
    client?.User?.Address?.CityId || "",
  );

  let [selectedReligion, setSelectedReligion] = useState(
    client?.ReligionId || "",
  );
  let [selectedCaste, setSelectedCaste] = useState(client?.CasteId || "");
  const [selectedLevel2Caste, setSelectedLevel2Caste] = useState("");
  const [selectedLevel3Caste, setSelectedLevel3Caste] = useState("");
  const [selectedCommunities, setSelectedCommunities] = useState(
    client?.CommunitiesId || "",
  );

  const [selectedMaritalStatus, setSelectedMaritalStatus] = useState(
    client?.MarriageStatusId || "",
  );
  const [selectedSkinTone, setSelectedSkinTone] = useState(client?.SkinToneId);
  const [selectedBuild, setSelectedBuild] = useState(client?.BuildId);
  const [selectedHabit, setSelectedHabit] = useState(
    client.ProfileHabits || [],
  );
  const [selectedHobbies, setSelectedHobbie] = useState(
    client.ProfileHobbies || [],
  );

  let [selectedDate, setSelectedDate] = useState(client?.User?.DOB);

  let [accessInactiveOrActive, setAccessInactiveOrActive] = useState(false);

  const [limitSameReligion, setLimitSameReligion] = useState(
    client.LimitSameReligion,
  );
  const [limitSameCaste, setLimitSameCaste] = useState(client.LimitSameCaste);
  const [limitSameSubCaste, setLimitSameSubCaste] = useState(
    client.LimitSameSubCaste,
  );
  const [limitSameSubCommunity, setLimitSameSubCommunity] = useState(
    client.LimitSameSubCommunity,
  );
  const [limitLanguage, setLimitLanguage] = useState(client.LimitLanguage);

  let [profileImages, setProfileImages] = useState([]);
  const [videoFile, setVideoFile] = useState(null);
  const [mainIndex, setMainIndex] = useState(0);
  const [docFile, setDocFile] = useState(null);
  const [docName, setDocName] = useState("");

  useEffect(() => {
    profileData.IsPhotoVisible = accessInactiveOrActive;
    setProfileData(profileData);
  }, [accessInactiveOrActive]);

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setLoading(true);
      let id = await getData(USER_ID);
      UserId = id;
      setUserId(UserId);
      let clientLogin = await getData(CLIENT_LOGIN);
      setIsClient(clientLogin);
      let profile = await getData(PROFILE_LOGIN);
      profileLogin = profile;
      setProfileLogin(profileLogin);
      if (clientLogin) {
        let resp = await get_client(id);
        console.log(resp.data);
        parentID = resp.data.ParentId || null;
        setParentId(parentID);
        console.log(resp.data);

        cleintGender = resp.data.Gender;
        setClientGender(cleintGender);
      }

      await fetchCountries();

      if (clientLogin) {
        let filteredRelations = clientRelationsMasterData || [];

        if (parentID) {
          filteredRelations = filteredRelations.filter((item) => item.id !== 1);
        } else {
          filteredRelations = filteredRelations.filter((item) =>
            [1, 4, 5, 8].includes(item.id),
          );
        }

        console.log(filteredRelations);
        setRelationsForClients(filteredRelations);
      }

      profileData = new Profile(client);
      setProfileData(profileData);
      if (client.ReligionId) {
        await getlevl2Caste(client?.ReligionId, null);
      }

      if (client.CasteLevel2Id) {
        setSelectedLevel2Caste(client.CasteLevel2Id);
        await getLevel3Caste(client.CasteLevel2Id);
      }

      if (client.CasteLevel3Id) {
        setSelectedLevel3Caste(client.CasteLevel3Id);
      }

      if (client?.User?.Address) {
        profileData.address.StateId = client?.User?.Address?.CountryId;
        profileData.address.StateId = client?.User?.Address?.StateId;
        profileData.address.CityId = client?.User?.Address?.CityId;
        profileData.address.AddressDetails =
          client?.User?.Address?.AddressDetails;
        setProfileData(profileData);

        console.log(
          "getting client?.User?.Address?.StateId",
          client?.User?.Address?.StateId,
        );
        console.log(
          "getting client?.User?.Address?.CityId",
          client?.User?.Address?.CityId,
        );

        if (client?.User?.Address?.CountryId) {
          setCountryCode(client?.User?.Address?.CountryId);
        }
        if (client?.User?.Address?.StateId) {
          setSelectedState(client?.User?.Address?.StateId);
        }
        if (client?.User?.Address?.CityId) {
          setSelectedCity(client?.User?.Address?.CityId);
        }
      }

      if (!client?.IsPhotoVisible) {
        profileData.IsPhotoVisible = false;
        setProfileData(profileData);
      }

      accessInactiveOrActive = client?.IsPhotoVisible;
      setAccessInactiveOrActive(accessInactiveOrActive);
      if (client?.User?.familyDetails) {
        setFamilyDetails(client.User.familyDetails);
        profileData.familyDetails = client.User.familyDetails;
        setProfileData(profileData);
      } else {
        setFamilyDetails([
          {
            RelationshipId: 1,
            FamilyMemberName: "",
            Occupation: "",
            RoleDesc: "",
          },
          {
            RelationshipId: 2,
            FamilyMemberName: "",
            Occupation: "",
            RoleDesc: "",
          },
        ]);
      }
      if (client?.User?.familyWealth) {
        setFamilyWealth(client.User.familyWealth);
        profileData.familyWealth = client.User.familyWealth;
        setProfileData(profileData);
      } else {
        setFamilyWealth([
          {
            PropertyType: "",
            Description: "",
            EstimatedValue: "",
            OwnershipType: "",
            Location: "",
            Notes: "",
          },
        ]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const [images, setImages] = useState([]);

  useEffect(() => {
    if (client?.User?.WedLukDocs?.[0]?.ProfileImages?.length) {
      const imageUrls = client.User.WedLukDocs[0].ProfileImages;
      const prepared = imageUrls.map((url) => ({
        file: null,
        preview: url,
      }));
      setImages(prepared);
    }
  }, [client]);

  const fetchCountries = async () => {
    try {
      // const res = await get_all_countries(); // replace with your endpoint
      const data = allCountyMasterData;

      if (data) {
        const formatted = data?.map((c) => ({
          value: c.isoCode,
          label: `+${c.phonecode} (${c.name})`,
          name: c.name,
        }));
        console.log("formatted get_all_countries", formatted);
        setCountries(formatted);
      }
    } catch (err) {
      console.error("Error fetching countries", err);
    }
  };

  useEffect(() => {
    if (!allCountyMasterData?.length) return;

    // 1️⃣ If profile already has SalaryCurrency → keep it
    if (client?.SalaryCurrency) {
      setSalaryCurrency(client.SalaryCurrency);
      return;
    }

    // 2️⃣ Else fallback to country currency
    if (countryCode) {
      const selectedCountry = allCountyMasterData.find(
        (c) => c.isoCode === countryCode,
      );

      if (selectedCountry?.currency) {
        setSalaryCurrency(selectedCountry.currency);
        return;
      }
    }

    // 3️⃣ Final fallback
    setSalaryCurrency("USD");
  }, [countryCode, allCountyMasterData]);

  useEffect(() => {
    console.log("Selectd countryCode", countryCode);

    if (countryCode) {
      (async () => {
        try {
          console.log("Selectd inside countryCode", countryCode);
          const res = await get_states(countryCode);
          if (res.success) {
            const formattedStates = res.data.map((s) => ({
              value: s.isoCode,
              label: s.name,
              countryCode: s.countryCode,
            }));
            console.log("formattedStates ", formattedStates);

            setStates(formattedStates);
            setSelectedState(null); // reset state
            setCities([]); // reset cities
          }
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      })();
    }
  }, [countryCode]);

  // 2️⃣ When state changes, fetch cities
  useEffect(() => {
    if (countryCode && selectedState) {
      (async () => {
        try {
          const res = await get_cities(countryCode, selectedState);
          if (res.success) {
            const formattedCities = res.data.map((c) => ({
              value: c.name,
              label: c.name,
              stateCode: c.stateCode,
              countryCode: c.countryCode,
              latitude: c.latitude,
              longitude: c.longitude,
            }));
            setCities(formattedCities);
            // setSelectedCity(null);
          }
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      })();
    }
  }, [selectedState, countryCode]);

  const handleReligionDataFromChild = (e) => {
    let id = Number(e.target.value);
    selectedReligion = id;
    setSelectedReligion(selectedReligion);
    setSelectedCaste("");
    setSelectedLevel2Caste("");
    setSelectedLevel3Caste("");
    // getLevel1Castes(id);
    getlevl2Caste(id, null);
  };

  const handlelevle2Caste = (e) => {
    let id = Number(e.target.value);
    setSelectedLevel2Caste(id);
    if (id) {
      getLevel3Caste(id);
    }
    setSelectedLevel3Caste("");
  };

  const getlevl2Caste = async (religionID, casteId) => {
    let data = await get_level2_caste(religionID, casteId);
    console.log("get_level2_caste", data);
    setLevel2Caste(data.data);
  };

  const handleMaritaStatusDataFromChild = (e) => {
    let id = Number(e.target.value);
    setSelectedMaritalStatus(id);
  };

  const handleCommunitiesDataFromChild = (e) => {
    let id = Number(e.target.value);
    setSelectedCommunities(id);
  };

  const handelDataFromSkinToneModal = (e) => {
    let id = Number(e.target.value);
    setSelectedSkinTone(id);
  };

  const handelDataFromBuildModal = (e) => {
    let id = Number(e.target.value);
    setSelectedBuild(id);
  };

  const [addresDet, setAddressDet] = useState(
    client?.User?.Address?.AddressDetails,
  );

  const handelAddreesDet = (e) => {
    let text = e.target.value;
    setAddressDet(text);
    profileData.address.AddressDetails = text;
  };

  const handleResidence = (e) => {
    let val = e.target.value;
    setSelectedResidence(val);
  };

  const handleCitizenship = (e) => {
    let val = e.target.value;
    setSelectedCitizenship(val);
  };

  const handleEthinicity = (e) => {
    let val = e.target.value;
    setSelectedEthinicity(val);
  };

  const handlePostalcode = (e) => {
    let val = e.target.value;
    setPostalCode(val);
  };

  const checkPhoneNumber = async (phno) => {
    let resp = await check_phone_no(phno);
    console.log(resp);
    return resp.success;
  };

  // const uploadPhotos = async (id) => {
  //   try {
  //     const imageFiles = profileImages.filter((item) => item instanceof File);

  //     const selectedImage = images[mainIndex];

  //     console.log("selectedImage?.file instanceof File",selectedImage?.file instanceof File);

  //     // =============================
  //     // CASE 1: NEW FILE SELECTED
  //     // =============================
  //     if (selectedImage?.file instanceof File) {
  //       const mainFile = selectedImage.file;

  //       const profilePhotoResponse = await update_profile_photo(id, mainFile);

  //       if (profilePhotoResponse.status !== 200) {
  //         alert("Profile photo upload failed.");
  //         return;
  //       }

  //       console.log("imageFiles",imageFiles);

  //       const clientPhotoResponse = await update_client_photo(id, imageFiles);

  //       console.log(clientPhotoResponse);

  //       if (clientPhotoResponse.status !== 200) {
  //         alert("Client photo upload failed.");
  //         return;
  //       }
  //     }

  //     // =============================
  //     // CASE 2: OLD IMAGE SELECTED
  //     // =============================
  //     else if (selectedImage) {
  //       const imageUrl =
  //         selectedImage.preview ||
  //         selectedImage.url ||
  //         selectedImage.source?.uri;

  //       const cleanUrl = imageUrl?.split("?")[0];

  //       console.log(cleanUrl);

  //       if (cleanUrl) {
  //         await set_main_profile_photo({
  //           userId: id,
  //           imageUrl: cleanUrl,
  //         });
  //       }
  //     }
  //     // =============================
  //     // VIDEO
  //     // =============================
  //     if (videoFile) {
  //       const videoResp = await update_profile_video(id, videoFile);
  //       if (videoResp.status !== 200) {
  //         alert("Video upload failed.");
  //         return;
  //       }
  //     }

  //     // =============================
  //     // DOCUMENT
  //     // =============================
  //     if (docFile && !docFile.isFromServer) {
  //       const doc = await update_profile_document(id, docFile, docName);
  //       if (doc.status !== 200) {
  //         alert("Document upload failed.");
  //         return;
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error in uploadPhotos:", error);
  //     alert("An error occurred while uploading.");
  //   } finally {
  //     setBtnLoading(false);
  //   }
  // };

  const uploadPhotos = async (id) => {
    try {
      const imageFiles = profileImages.filter((item) => item instanceof File);

      const selectedImage = images[mainIndex];

      console.log("mainIndex:", mainIndex);
      console.log("selectedImage:", selectedImage);
      console.log("imageFiles:", imageFiles);

      // ==========================================
      // UPLOAD NEW IMAGES (if any)
      // ==========================================
      if (imageFiles.length > 0) {
        let mainFile = null;

        // If selected image is a newly uploaded file
        if (selectedImage?.file instanceof File) {
          mainFile = selectedImage.file;
        } else {
          // fallback to first uploaded image
          mainFile = imageFiles[0];
        }

        // Upload Main Profile Photo
        const profilePhotoResponse = await update_profile_photo(id, mainFile);

        if (profilePhotoResponse.status !== 200) {
          alert("Profile photo upload failed.");
          return;
        }

        // Upload All Photos
        const clientPhotoResponse = await update_client_photo(id, imageFiles);

        if (clientPhotoResponse.status !== 200) {
          alert("Client photo upload failed.");
          return;
        }

        // If user selected an old image as main photo,
        // set it again after upload
        if (selectedImage && !(selectedImage?.file instanceof File)) {
          const imageUrl =
            selectedImage.preview ||
            selectedImage.url ||
            selectedImage.source?.uri;

          const cleanUrl = imageUrl?.split("?")[0];

          if (cleanUrl) {
            await set_main_profile_photo({
              userId: id,
              imageUrl: cleanUrl,
            });
          }
        }
      }

      // ==========================================
      // ONLY CHANGE MAIN PHOTO (NO NEW UPLOADS)
      // ==========================================
      else if (selectedImage) {
        const imageUrl =
          selectedImage.preview ||
          selectedImage.url ||
          selectedImage.source?.uri;

        const cleanUrl = imageUrl?.split("?")[0];

        if (cleanUrl) {
          await set_main_profile_photo({
            userId: id,
            imageUrl: cleanUrl,
          });
        }
      }

      // ==========================================
      // VIDEO
      // ==========================================
      if (videoFile) {
        const videoResp = await update_profile_video(id, videoFile);

        if (videoResp.status !== 200) {
          alert("Video upload failed.");
          return;
        }
      }

      // ==========================================
      // DOCUMENT
      // ==========================================
      if (docFile && !docFile.isFromServer) {
        const doc = await update_profile_document(id, docFile, docName);

        if (doc.status !== 200) {
          alert("Document upload failed.");
          return;
        }
      }

      console.log("All uploads completed successfully");
    } catch (error) {
      console.error("Error in uploadPhotos:", error);
      alert("An error occurred while uploading.");
    } finally {
      setBtnLoading(false);
    }
  };
  const renderRelations = () => {
    return maritalStatus.map((item, index) => (
      <option key={index} value={item.MarriageStatusId}>
        {item.MarriageStatus}
      </option>
    ));
  };

  const renderRelationsForClient = () => {
    return relationsForClient.map((item, index) => (
      <option key={index} value={item.id}>
        {item.RelationName}
      </option>
    ));
  };

  const handleClientRelations = (e) => {
    const id = Number(e.target.value);
    setSelectedRelationFrClient(id);
  };

  const renderReligion = () => {
    return religion.map((item, index) => (
      <option key={index} value={item.ReligionId}>
        {item.ReligionName}
      </option>
    ));
  };

  const renderCommunity = () => {
    return communityList.map((item, index) => (
      <option key={index} value={item.CommunitiesId}>
        {item.CommunitiesName}
      </option>
    ));
  };
  const renderLevel2Caste = () => {
    return level2Caste?.map((item, index) => (
      <option key={index} value={item.CasteL2Id}>
        {item.CasteName}
      </option>
    ));
  };
  const renderLang = () => {
    return languages.map((item, index) => (
      <option key={index} value={item.LangId}>
        {item?.LangDesc}
      </option>
    ));
  };

  const getLevel3Caste = async (id) => {
    console.log(selectedCaste);

    let resp = await get_level3_caste(selectedCaste, id);
    setLevel3Caste(resp.data);
  };

  const renderLevel3Caste = () => {
    return level3Caste?.map((item, index) => (
      <option key={index} value={item.CasteL3Id}>
        {item.CasteName}
      </option>
    ));
  };

  const handleLevel3Caste = (e) => {
    let id = Number(e.target.value);
    setSelectedLevel3Caste(id);
  };

  const handleSelect = (e) => {
    const selectedId = Number(e.target.value);
    const lang = languages.find((l) => l.LangId === selectedId);
    if (!lang) return;

    setSelectedLanguage((prev) =>
      prev.some((c) => c.LangId === lang.LangId)
        ? prev
        : [...prev, lang.LangId],
    );
  };

  const removeLanguage = (langToRemove) => {
    setSelectedLanguage((prev) => prev.filter((c) => c !== langToRemove));
  };

  useEffect(() => {
    console.log("Selected Images:", profileImages);
  }, [profileImages]);

  const showToast = (message) => {
    const toast = document.getElementById("toast-message");
    if (!toast) return;

    toast.innerText = message;
    toast.style.display = "block";

    // Force reflow to restart animation
    void toast.offsetWidth;

    toast.style.animation = "fadeInOut 3s ease-in-out";

    // Hide again after animation
    setTimeout(() => {
      toast.style.display = "none";
    }, 3000);
  };

  const validateAdress = () => {
    if (!countryCode) {
      showToast("Choose Country");
      setBtnLoading(false);
      return false;
    }
    if (!selectedState) {
      showToast("Choose State");
      setBtnLoading(false);
      return false;
    }

    if (!selectedCity) {
      showToast("Choose City");
      setBtnLoading(false);
      return false;
    }
    if (!addresDet) {
      showToast("Enter Address Details");
      setBtnLoading(false);
      return false;
    }

    return true;
  };

  const validateCaste = () => {
    // if (!selectedCaste) {
    //   showToast("Choose Caste");
    //   setBtnLoading(false);
    //   return false;
    // }
    if (!selectedLevel2Caste) {
      showToast("Choose sub caste");
      setBtnLoading(false);
      return false;
    }
    if (!selectedLevel3Caste) {
      showToast("Choose sub caste Community");
      setBtnLoading(false);
      return false;
    }
    return true;
  };

  const getLatitude = (name) => {
    let val = cities.filter((id) => id.label === name);
    console.log("val.longitude", val[0].latitude);

    return val[0].latitude || "";
  };

  const getLongitude = (name) => {
    let val = cities.filter((id) => id.label === name);
    return val[0].longitude || "";
  };

  useEffect(() => {
    if (client?.User?.WedLukDocs?.[0]?.ProfileImages?.length) {
      const imageUrls = client.User.WedLukDocs[0];

      console.log(imageUrls);
      setDocFile({
        name: imageUrls.ProfileDocsName,
        url: imageUrls.ProfileDocs,
        isFromServer: true,
      });
      setDocName(imageUrls?.ProfileDocsName);
    }
  }, [client]);

  const validateContactChanges = async () => {
    try {
      const oldPhone = client?.User?.PhoneNumber;
      const oldEmail = client?.User?.EMail;

      // ✅ PHONE
      if (phoneNumber && phoneNumber !== oldPhone) {
        const resp = await check_phone_no(phoneNumber);

        if (!resp.success) {
          showToast("Phone number already exists");
          return false;
        }
      }

      // ✅ EMAIL (if you have API)
      if (email && email !== oldEmail) {
        const resp = await check_email(email);

        if (!resp.success) {
          showToast("Email already exists");
          return false;
        }
      }

      return true;
    } catch (err) {
      console.log(err);
      showToast("Validation failed");
      return false;
    }
  };

  const EditProfile = async () => {
    if (btnLoading) return;
    setBtnLoading(true);

    if (!validateAdress()) return;
    if (!validateCaste()) return;

    const isValid = await validateContactChanges();
    if (!isValid) {
      setBtnLoading(false);
      return;
    }

    userData.FirstName = firstName;
    userData.LastName = lastName;
    userData.FatherName = middleName;
    userData.DOB = selectedDate;
    userData.Gender = selectedGender;
    userData.UserLanguage = selectedLanguage;
    userData.UserId = userIdForProfile;

    if (countryCode) {
      profileData.address.CountryId = countryCode;
      console.log("CountryId set to:", countryCode);
    } else {
      delete profileData.address.CountryId;
      console.log("CountryId deleted");
    }

    if (selectedState) {
      profileData.address.StateId = selectedState;
      console.log("StateId set to:", selectedState);
    }

    if (selectedCity) {
      profileData.address.CityId = selectedCity;
      console.log("CityId set to:", selectedCity);

      profileData.address.Latitude = getLatitude(selectedCity);
      profileData.address.Longitude = getLongitude(selectedCity);
    }

    if (selectedResidence) {
      profileData.address.ResidenceId = selectedResidence;
    } else {
      delete profileData.address.ResidenceId;
    }

    if (selectedCitizenship) {
      profileData.address.CitizenshipId = selectedCitizenship;
    } else {
      delete profileData.address.CitizenshipId;
    }

    if (seletedEthinicity) {
      profileData.address.Ethinicity = seletedEthinicity;
    } else {
      delete profileData.address.Ethinicity;
    }

    if (postalcode) {
      profileData.address.PostalCode = postalcode + "";
    } else {
      delete profileData.address.PostalCode;
    }

    profileData.ProfileDescription = desc;
    profileData.RelationId = selectedRelation;
    profileData.MarriageStatusId = selectedMaritalStatus;
    profileData.ReligionId = selectedReligion;
    profileData.CasteId = selectedCaste;
    profileData.CasteLevel2Id = selectedLevel2Caste;
    profileData.CasteLevel3Id = selectedLevel3Caste;
    profileData.CommunitiesId = selectedCommunities;
    profileData.Height = height;
    profileData.Weight = weight;
    profileData.QualificationId = selectedQualification;
    profileData.JobRole = jobRole;
    profileData.CollageName = collageName;
    profileData.BuildId = selectedBuild;
    profileData.SkinToneId = selectedSkinTone;
    profileData.ProfileHabits = selectedHabit;
    profileData.ProfileHobbies = selectedHobbies;
    profileData.Salary = Salary;
    profileData.SalaryCurrency = salaryCurrency;
    profileData.familyDetails = familyDetails;
    profileData.familyWealth = familyWealth;
    profileData.CarrerGoals = carrerGoals;

    profileData.ProfileId = profileId;

    profileData.LimitSameReligion = limitSameReligion;
    profileData.LimitSameCaste = limitSameCaste;
    profileData.LimitSameSubCaste = limitSameSubCaste;
    profileData.LimitSameSubCommunity = limitSameSubCommunity;
    profileData.LimitLanguage = limitLanguage;

    if (isClient) {
      profileData.ClientRelationId = selectedRelationFrClient;
      profileData.ClientRelationOwnerId = parentID ? parentID : cleintGender;
    }

    // Remove empty values
    Object.keys(userData).forEach((key) => {
      if (!userData[key]) {
        delete userData[key];
      }
    });

    Object.keys(profileData).forEach((key) => {
      const value = profileData[key];
      if (value === null || value === undefined || value === "") {
        delete profileData[key];
      }
    });

    if (Object.values(profileData.address || {}).some((val) => val === null)) {
      delete profileData.address;
    }

    setUserData(userData);
    console.log("userData", userData);
    console.log(profileData);
    profileData.userInfo = userData;
    profileData.IsPhotoVisible = accessOnRequest;

    delete profileData.AgentId;
    setProfileData(profileData);

    console.log("profileData", selectedHobbies, selectedHabit);

    try {
      let resp = await edit_profile(profileData);
      console.log("edit_profile", resp);

      if (resp.code === 200) {
        let data = {
          profileId: profileId,
        };

        // runMatchesAloritm(data);
        await uploadPhotos(resp.data.User.UserId);
        if (profileLogin) {
          navigate("/profileforclient", { state: { client: client } });
        } else {
          navigate("/profile", { state: { client: client } });
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      console.log("finnaly done");
      setBtnLoading(false);
    }
  };

  const runMatchesAloritm = async (data) => {
    let runpreferanceAlogritm = await create_matches_by_preference(data);
    console.log(runpreferanceAlogritm);
  };

  if (Loading)
    return (
      <div className="loading-screen">
        <img src={logo} alt="Logo" className="logo-3d" />
      </div>
    );

  return (
    <div className="main-new-client">
      {/* Fixed Header */}
      <header className="top-header">
        <div className="header-content" onClick={EditProfile}>
          <img
            src={logo}
            alt="WedLuk Logo"
            className="logos"
            style={{ height: "60px", cursor: "pointer" }}
          />
          <span className="nav-item">
            Update {client?.User?.FirstName} {client?.User?.LastName} profile
          </span>
        </div>
      </header>

      {/* Main Content */}
      <div className="create-client-container ">
        <div className="">
          <div className="card-new-client">
            <h2 className="section-title-for-new-client">Profile Settings</h2>

            {isClient && (
              <div className="lable2-for-new-client mt-1">
                Select a Relation to Create Profile
              </div>
            )}
            {isClient && (
              <div className="form-group-new-client">
                <select
                  required
                  value={selectedRelationFrClient}
                  onChange={handleClientRelations}
                >
                  <option>Select a Relation to Create Profile</option>
                  {renderRelationsForClient()}
                </select>
              </div>
            )}

            <div className="lable2-for-new-client">Enter Groom/Bride Name</div>
            <div className="d-flex justify-content-between">
              <div className="form-group-new-client w-50 me-2">
                <input
                  type="text"
                  placeholder=" First Name"
                  value={firstName}
                  required
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div className="form-group-new-client w-50 ms-2">
                <input
                  type="text"
                  placeholder=" Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>

            <div className="d-flex">
              <div className="w-50  me-2">
                <div className="lable2-for-new-client mt-1">Select Gender</div>

                <div className="form-group-new-client">
                  <select
                    required
                    value={selectedGender}
                    onChange={handleGenderDataFromChild}
                  >
                    <option> Select Gender</option>
                    <option value={1}> Male</option>
                    <option value={2}> Female</option>
                  </select>
                </div>
              </div>

              <div className="w-50 ms-2">
                <div className="lable2-for-new-client mt-1">Select Country</div>

                <div className="form-group-new-client">
                  <Select
                    options={countries}
                    placeholder="Select Country"
                    value={
                      countries.find((c) => c.value === countryCode) || null
                    }
                    onChange={(option) => setCountryCode(option.value)}
                    isSearchable
                    styles={customStyles}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex">
              <div className="w-50 me-2">
                <div className="lable2-for-new-client mt-1">Phone Number</div>

                <div className="form-group-new-client">
                  <input
                    type="text"
                    placeholder="Enter Phone Number"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>
              </div>

              <div className="w-50 ms-2">
                <div className="lable2-for-new-client mt-1">Email</div>

                <div className="form-group-new-client">
                  <input
                    type="email"
                    placeholder="Enter Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="background-section__row">
              <label
                className="lable2-for-new-client"
                htmlFor="relationshipHistory"
              >
                Relationship history
              </label>
              <select
                id="relationshipHistory"
                className="background-section__input"
                onChange={handleMaritaStatusDataFromChild}
                value={selectedMaritalStatus}
              >
                <option value="">Select Relationship history</option>
                {renderRelations()}
              </select>
            </div>
            <div className="background-section__row">
              <label
                className="lable2-for-new-client"
                htmlFor="relationshipHistory"
              >
                Select State
              </label>

              <Select
                options={states}
                placeholder="Select State"
                value={states.find((s) => s.value === selectedState) || null}
                onChange={(option) =>
                  setSelectedState(option ? option.value : "")
                }
                isDisabled={!countryCode}
                isSearchable
                styles={customStyles}
              />
            </div>
            <div className="background-section__row">
              <label
                className="lable2-for-new-client"
                htmlFor="relationshipHistory"
              >
                Select City
              </label>

              <Select
                options={cities}
                placeholder="Select City"
                value={cities.find((c) => c.value === selectedCity) || null}
                onChange={(option) =>
                  setSelectedCity(option ? option.value : "")
                }
                isDisabled={!selectedState}
                isSearchable
                styles={customStyles}
              />
            </div>
            <div className="background-section__row">
              <label
                className="lable2-for-new-client"
                htmlFor="relationshipHistory"
              >
                Profile Description
              </label>
              <input
                type="text"
                value={desc}
                className="background-section__input"
                // placeholder="Enter Profile Description"
                placeholder="EX: Family-oriented, emotionally mature, and professionally settled—seeking a life partner to grow with."
                onChange={(e) => setDesc(e.target.value)}
              />
            </div>
            <div className="background-section__row">
              <label
                className="lable2-for-new-client"
                htmlFor="relationshipHistory"
              >
                Select Community
              </label>
              <select
                className="background-section__input"
                value={selectedCommunities}
                onChange={handleCommunitiesDataFromChild}
              >
                <option value="">Select Community</option>
                {renderCommunity()}
              </select>
            </div>

            <div className="profile-match-limits">
              <div className="field-pair">
                <div className="select-block">
                  <label>Select Religion</label>
                  <select
                    value={selectedReligion}
                    onChange={handleReligionDataFromChild}
                  >
                    <option>Select Religion</option>
                    {renderReligion()}
                  </select>
                </div>
                {/* <div className="checkbox-block">
                  <label>
                    <input
                      type="checkbox"
                      checked={limitSameReligion}
                      onChange={(e) => setLimitSameReligion(e.target.checked)}
                    />
                    Limit matches to same Religion
                  </label>
                </div> */}
              </div>

              {/* <div className="field-pair">
                <div className="select-block">
                  <label>Select Sect / Varna</label>
                  <select
                    required
                    value={selectedCaste}
                    onChange={handleCasteDataFromChild}
                  >
                    <option>Select Sect / Varna</option>
                    {renderCaste()}
                  </select>
                </div>
                <div className="checkbox-block">
                  <label>
                    <input
                      type="checkbox"
                      checked={limitSameCaste}
                      onChange={(e) => setLimitSameCaste(e.target.checked)}
                    />
                    Limit matches to same Sect / Varna
                  </label>
                </div>
              </div> */}
              <div className="field-pair">
                <div className="select-block">
                  <label>Select Caste</label>
                  <select
                    value={selectedLevel2Caste}
                    onChange={handlelevle2Caste}
                    required
                  >
                    <option>Select Caste</option>
                    {renderLevel2Caste()}
                  </select>
                </div>
                {/* <div className="checkbox-block">
                  <label>
                    <input
                      type="checkbox"
                      checked={limitSameSubCaste}
                      onChange={(e) => setLimitSameSubCaste(e.target.checked)}
                    />
                    Limit matches to same Caste
                  </label>
                </div> */}
              </div>
              <div className="field-pair">
                <div className="select-block">
                  <label>Select Sub Caste</label>
                  <select
                    value={selectedLevel3Caste}
                    onChange={handleLevel3Caste}
                    required
                  >
                    <option>Select Sub Caste</option>
                    {renderLevel3Caste()}
                  </select>
                </div>
                {/* <div className="checkbox-block">
                  <label>
                    <input
                      type="checkbox"
                      checked={limitSameSubCommunity}
                      onChange={(e) =>
                        setLimitSameSubCommunity(e.target.checked)
                      }
                    />
                    Limit matches to same Sub Caste
                  </label>
                </div> */}
              </div>

              <div className="field-pair">
                <div className="select-block">
                  <label>Select Language </label>
                  <select onChange={handleSelect}>
                    <option>Select Language</option>
                    {renderLang()}
                  </select>
                </div>
                {/* <div className="checkbox-block">
                  <label>
                    <input type="checkbox" />
                    Limit matches to same language
                  </label>
                </div> */}
                {selectedLanguage.length > 0 && (
                  <div className="selected-forwred-client">
                    {languages
                      .filter((i) => selectedLanguage.includes(i.LangId))
                      ?.map((lang) => (
                        <span key={lang.LangId} className="tag">
                          {lang.LangDesc}
                          <button
                            className="click-effect"
                            onClick={() => removeLanguage(lang.LangId)}
                          >
                            X
                          </button>
                        </span>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <BackgroundInfoSection
          dob={selectedDate}
          setDob={setSelectedDate}
          countryList={countryList}
          addresDet={addresDet}
          handelAddreesDet={handelAddreesDet}
          communityList={communityList}
          selectedResidence={selectedResidence}
          handleResidence={handleResidence}
          selectedCitizenship={selectedCitizenship}
          handleCitizenship={handleCitizenship}
          seletedEthinicity={seletedEthinicity}
          handleEthinicity={handleEthinicity}
          postalcode={postalcode}
          handlePostalcode={handlePostalcode}
        />

        <AddFamilyMemeberForClient
          familyDetails={familyDetails}
          setFamilyDetails={setFamilyDetails}
        />

        <AddFamilyWealthForClient
          familyWealth={familyWealth}
          setFamilyWealth={setFamilyWealth}
        />

        <EducationWorkForm
          qualifications={qualifications}
          handleQualificationDataFromChild={handleQualificationDataFromChild}
          selectedQualification={selectedQualification}
          collageName={collageName}
          setCollageName={setCollageName}
          jobRole={jobRole}
          setJobRole={setJobRole}
          Salary={Salary}
          setSalary={setSalary}
          carrerGoals={carrerGoals}
          setcarrerGoals={setcarrerGoals}
          salaryCurrency={salaryCurrency}
          setSalaryCurrency={setSalaryCurrency}
          allCountyMasterData={allCountyMasterData}
        />

        <PhysicalAttributesForm
          height={height}
          setHeight={setHeight}
          weight={weight}
          setWeight={setWeight}
          skinToneList={skinToneList}
          selectedSkinTone={selectedSkinTone}
          handelDataFromSkinToneModal={handelDataFromSkinToneModal}
          physicalbuildList={physicalbuildList}
          selectedBuild={selectedBuild}
          handelDataFromBuildModal={handelDataFromBuildModal}
        />

        <EditPhotographUploader
          client={client}
          images={images}
          setImages={setImages}
          setProfileImages={setProfileImages}
          accessOnRequest={accessOnRequest}
          setAccessOnRequest={setAccessOnRequest}
          mainIndex={mainIndex}
          setMainIndex={setMainIndex}
        />

        <LifestyleAndInterests
          habitList={habitList}
          selectedHabit={selectedHabit}
          setSelectedHabit={setSelectedHabit}
          hobbiesList={hobbiesList}
          selectedHobbies={selectedHobbies}
          setSelectedHobbie={setSelectedHobbie}
        />

        <VideoAndDocumentsUploader
          videoFile={videoFile}
          setVideoFile={setVideoFile}
          communitieDocs={communitieDocs}
          docFile={docFile}
          setDocFile={setDocFile}
          docName={docName}
          setDocName={setDocName}
          selectedReligion={selectedReligion}
        />

        <div className="button-row">
          <button
            className="back-btn click-effect"
            onClick={() => setCurrentStep((prev) => prev - 1)}
          >
            Back
          </button>

          <button
            className="create-btn click-effect"
            onClick={EditProfile}
            disabled={btnLoading}
          >
            {btnLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </>
            ) : (
              "Save Profile"
            )}
          </button>
        </div>
      </div>
      <div id="toast-message"></div>
    </div>
  );
}
